import { useEffect, useMemo, useState } from 'react';
export function useTheme() {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('theme') || 'dark';
    });
    useEffect(() => {
        document.documentElement.dataset.theme = theme;
        localStorage.setItem('theme', theme);
    }, [theme]);
    return {
        theme,
        toggleTheme() {
            setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
        }
    };
}
export function useLocalFlag(key, initial = false) {
    const [value, setValue] = useState(() => localStorage.getItem(key) === '1' || initial);
    useEffect(() => {
        localStorage.setItem(key, value ? '1' : '0');
    }, [key, value]);
    return [value, setValue];
}
export function useDebouncedValue(value, delay = 300) {
    const [current, setCurrent] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setCurrent(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);
    return useMemo(() => current, [current]);
}
